import {Packer} from "docx";
import type {Editor} from "slate";

import {createDocFromEditor} from "@khan/component-rich-text-editor";
import type {GuideComponents} from "@khan/guide-core";
import {createPPTxFromSlides} from "@khan/khanmigo-pptx";

import {getDocumentTitle} from "../slate/helpers/editor-helpers.ts";
import {clearUnsavedChanges} from "../slate/helpers/insertion-helpers.ts";

export const downloadAsDocx = async (
    editor: Editor,
    title?: string,
): Promise<void> => {
    clearUnsavedChanges(editor);
    const docTitle = title ?? getDocumentTitle(editor);

    const doc = createDocFromEditor(editor, "docx-download");
    const blob = await Packer.toBlob(doc);

    const a = document.createElement("a");
    a.download = `${docTitle}.docx`;
    a.href = URL.createObjectURL(blob);

    a.addEventListener("click", () => {
        // eslint-disable-next-line no-restricted-syntax -- porting from old code.
        setTimeout(() => URL.revokeObjectURL(a.href), 1500);
    });
    a.click();
};

export const downloadAsPPTx = async (
    editor: Editor,
    title: string,
    slides: GuideComponents["CreateSlides"]["output"]["slides"],
): Promise<void> => {
    clearUnsavedChanges(editor);

    const pptxBlob = await createPPTxFromSlides(slides);

    const a = document.createElement("a");
    a.download = `${title}.pptx`;
    a.href = URL.createObjectURL(pptxBlob);

    a.addEventListener("click", () => {
        // eslint-disable-next-line no-restricted-syntax -- porting from old code.
        setTimeout(() => URL.revokeObjectURL(a.href), 1500);
    });
    a.click();
};
